import React from 'react'
import moment from 'moment'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import { DatePicker } from '@mui/x-date-pickers'

const Filters = props => {
  const { onChangeDate, selectedDate } = props
  const value = selectedDate || moment()
  const maxDate = moment().add(2, 'weeks')

  return (
    <Box align='center'>
      <DatePicker
        id='date'
        variant='inline'
        autoOk
        disablePast
        maxDate={maxDate}
        label='Select a date:'
        value={value}
        format='ddd, MMMM D'
        onChange={onChangeDate}
        renderInput={props => <TextField variant='standard' {...props} />}
      />
    </Box>
  )
}

export default Filters
